export default __webpack_public_path__ + "static/media/oxygen.35cd4b81.png";